module.exports = __webpack_public_path__ + "img/04-thumb.aa5d0036.png";